import styled, { css } from 'styled-components';

export const Element = styled.div<{ status?: string }>`
  ${({ theme, status, ...props }) => {
    return css`
      ${status === 'collapsed' &&
      css`
        display: none;
      `};
      ${status === 'collapsing' &&
      css`
        height: 0;
        overflow: hidden;
        transition: height 0.35s ease;
      `};
    `;
  }};
`;
